module.exports = __webpack_public_path__ + "static/img/3.54330a91.png";